module.exports = __webpack_public_path__ + "static/media/insurance.26d59ced.svg";